function findValue(row, key) {
  const match = Object.keys(row).find(
    (k) => k.replace(/\s+/g, "").toLowerCase() === key.toLowerCase()
  );
  return match ? row[match] : undefined;
}

export function cleanDataset(rawData) {
  if (!Array.isArray(rawData)) return [];

  return rawData
    .map((row) => {
      const name = findValue(row, "extension_name");
      const category = findValue(row, "category");
      const users = findValue(row, "users_count");
      const rating = findValue(row, "rating_value");
      const ratingCount = findValue(row, "rating_count");
      const subcategory = findValue(row, "subcategory");
      const rank = findValue(row, "rank_in_subcategory");

      return {
        name: String(name || "").trim(),
        category: String(category || "").trim(),
        subcategory: String(subcategory || "Unknown").trim(),
        users: Number(users) || 0,
        rating: Number(rating) || 0,
        ratingCount: Number(ratingCount) || 0,
        rank: Number(rank) || 0,
      };
    })
    .filter((row) => row.name.length > 0 && row.users >= 0);
}
